import {
  ALERT_DATA_ERROR,
  ALERT_DATA_SUCCESS,
  ALERT_MULTIMEDIA_STATE_CHANGE,
  ALERT_RESET_COMPOSE,
  ALERT_SEARCH_LIST_CHANGED,
  ALERT_SET_WARNING,
  ALERT_TOGGLE_RIGHTPANEL,
  ALERT_TOGGLE_SEARCHBAR,
  ALERT_TOGGLE_UPDATE_ALERT,
  ALERT_TOGGLE_WARNING,
  ALERT_UPDATE_COMPOSE_DATA,
  ALERT_UPDATE_DATA_LIST,
  ALERT_UPDATE_LIST,
  ALERT_UPDATE_LIST_ITEM,
  ALERT_UPDATE_LIST_ITEM_TYPE,
  ALERT_UPDATE_NODE,
  ALERT_UPDATE_TAB_ID,
  ALERT_UPDATE_TAB_NUM
} from "../actions";

import { StepperStates } from "../components";

import { AlertsListItem } from "../controllers/alerts/components";

const INITIAL_STATE = {
  data: null,
  composeData: {
    alertDetails: {
      severity: {
        type: 'MINOR',
        id: 0
      },
      incidentLocation: {
        center: {
          lat: 41.9,
          lng: -87.624
        },
        status: false,
        marker: null
      },
      expiration: {
        value: null,
        custom: {
          days: 0,
          hours: 0,
          minutes: 0
        }
      },
      iPawsDetails: {
        moreInfo: false,
        category: {
          value: null
        },
        eventCode: {
          value: null
        },
        urgency: {
          value: null
        },
        certainty: {
          value: null
        },
        reponseType: {
          value: null
        },
        timeZone: {
          value: null
        }
      },
      senderName: {
        value: ''
      },
      emailFrom: {
        value: ''
      },
      emailReply: {
        value: ''
      },
      voice: {
        callerId: {
          value: ''
        },
        callerName: {
          value: ''
        }
      }
    },
    chooseAudience: {
      audiences: {
        everyone: {
          status: false
        },
        groups: {
          selected: 0,
          status: false,
          groupTagList: [],
          list: [
            {
              title: "Group Name One",
              checked: false,
              description: "Here is a description we can add",
              type: "public",
              members: "37"
            },
            {
              title: "Group Name Two",
              checked: false,
              description: "Here is a description we can add",
              type: "private",
              members: "37"
            },
            {
              title: "Group Name Three",
              checked: false,
              description: "Here is a description we can add",
              type: "private",
              members: "37"
            },
            {
              title: "Group Name Four but its really long",
              checked: false,
              description: "Here is a description we can add",
              type: "public",
              members: "37"
            }
          ]
        }
      },
      geoFence: {
        center: {
          lat: 41.9,
          lng: -87.624
        },
        status: false,
        list: [],
        currentShape: null,
        search: {
          value: null
        }
      }
    },
    selectChannels: {
      spot: {
        status: false
      },
      iPaws: {
        status: false,
        list: [
          {
            EAS: {
              title: "EAS",
              status: false
            }
          },
          {
            WEA: {
              title: "WEA",
              status: false
            }
          },
          {
            NWEM: {
              title: "NWEM",
              status: false
            }
          },
          {
            CAPEXCH: {
              title: "CAPEXCH",
              status: false
            }
          }
        ]
      },
      twitter: {
        status: false,
        list: [
          {
            account1: {
              status: false
            }
          },
          {
            account2: {
              status: false
            }
          },
          {
            account3: {
              status: false
            }
          }
        ]
      },
      facebook: {
        status: false,
        list: [
          {
            account1: {
              status: false
            }
          },
          {
            account2: {
              status: false
            }
          },
          {
            account3: {
              status: false
            }
          }
        ]
      }
    },
    composeMessage: {
      messageDetails: {
        moreInfo: false,
        description: {
          value: ''
        },
        headline: {
          value: ''
        },
        instructions: {
          value: ''
        },
        wea: {
          value: ''
        }
      },
      multiMedia: {
        state: "init",
        uploadPercentage: null,
        fileName: null,
        fileTypes: null,
        files: [],
        voice: {
          state: null,
          timer: null
        }
      }
    },
    loading: false,
    previewSend: {
      launch1: "",
      launch2: "",
      launch3: "",
      launch4: "",
      launchCode: false
    },
    stepper: {
      step: 0,
      finished: 0,
      data: [
        {
          title: "Choose Audience",
          nav: "choose-audience",
          state: StepperStates.active,
          num: "1"
        },
        {
          title: "Select Channels",
          nav: "select-channels",
          state: StepperStates.default,
          num: "2"
        },
        {
          title: "Alert Details",
          nav: "alert-details",
          state: StepperStates.default,
          num: "3"
        },
        {
          title: "Compose Message",
          nav: "compose-message",
          state: StepperStates.default,
          num: "4"
        },
        {
          title: "Preview & Send",
          nav: "preview-send",
          state: StepperStates.default,
          num: "5"
        }
      ]
    },
    showBottomBar: false,
    copiedData: null,
    scheduledTime: null,
    scheduledDate: null
  },
  error: "",
  alertsActive: false,
  tabId: null,
  tabNum: 0,
  listItem: null,
  list: [],
  listItemType: AlertsListItem,
  nodeData: null,
  rightPanelExpanded: false,
  searchBarText: "",
  searchBarActive: false,
  searchFound: false,
  warningActive: false,
  updateAlertState: "init",
  multiMedia: {
    state: "init",
    uploadPercentage: null,
    fileName: null,
    fileTypes: null,
    files: [],
    voice: {
      state: null,
      timer: null
    }
  },
  warningContent: {
    header: "",
    body: ""
  },
  composePanelStack: null
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ALERT_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        list: action.list
      };
    case ALERT_SET_WARNING:
      return {
        ...state,
        warningContent: action.payload
      };
    case ALERT_DATA_ERROR:
      return { ...state, error: action.payload, data: null };
    case ALERT_UPDATE_TAB_ID:
      return {
        ...state,
        tabId: action.payload
      };
    case ALERT_UPDATE_TAB_NUM:
      return {
        ...state,
        tabNum: action.payload
      };
    case ALERT_UPDATE_COMPOSE_DATA:
      return {
        ...state,
        composeData: action.payload
      };
    case ALERT_UPDATE_DATA_LIST:
      const data = JSON.parse(JSON.stringify(state.data));
      data.list = action.payload;
      return {
        ...state,
        data
      };
    case ALERT_UPDATE_LIST:
      return {
        ...state,
        list: action.payload
      };
    case ALERT_UPDATE_LIST_ITEM:
      return {
        ...state,
        listItem: action.payload
      };
    case ALERT_UPDATE_LIST_ITEM_TYPE:
      return {
        ...state,
        listItemType: action.payload
      };
    case ALERT_UPDATE_NODE:
      return {
        ...state,
        nodeData: action.payload
      };
    case ALERT_TOGGLE_RIGHTPANEL:
      return {
        ...state,
        rightPanelExpanded: action.payload
      };
    case ALERT_RESET_COMPOSE:
      return {
        ...state,
        composeData: INITIAL_STATE.composeData
      };
    case ALERT_TOGGLE_UPDATE_ALERT:
      return {
        ...state,
        updateAlertState: action.payload
      };
    case ALERT_TOGGLE_SEARCHBAR:
      return {
        ...state,
        searchBarActive: action.payload
      };
    case ALERT_SEARCH_LIST_CHANGED:
      return {
        ...state,
        searchBarText: action.payload,
        searchFound: action.searchFound
      };
    case ALERT_MULTIMEDIA_STATE_CHANGE:
      return {
        ...state,
        multiMedia: action.payload
      };
    case ALERT_TOGGLE_WARNING:
      return {
        ...state,
        warningActive: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/Alerts.tsx